import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const PROFILES = [
  { key: '1', icon: 'ri-home-heart-line', color: 'text-terracotta-300' },
  { key: '2', icon: 'ri-global-line', color: 'text-olive-400' },
  { key: '3', icon: 'ri-building-3-line', color: 'text-gold-300' },
];

const PerChiSection = () => {
  const { t } = useTranslation();
  const header = useScrollAnimation();
  const cards = useScrollAnimation({ threshold: 0.1 });

  const titleLines = t('perchi.title').split('\n');

  return (
    <section
      id="perchi"
      className="bg-gradient-to-b from-ivory-50 to-white py-24 md:py-32 px-6"
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div
          ref={header.ref}
          className={`text-center mb-20 fade-in-up ${header.isVisible ? 'visible' : ''}`}
        >
          <p className="font-sans text-xs tracking-widest2 uppercase text-terracotta-300 mb-5">
            {t('perchi.overline')}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-anthracite-800 font-light leading-tight">
            {titleLines.map((line, i) => (
              <span key={i}>
                {line}
                {i < titleLines.length - 1 && <br />}
              </span>
            ))}
          </h2>
        </div>

        {/* Profile cards */}
        <div
          ref={cards.ref}
          className={`grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 fade-in-up ${cards.isVisible ? 'visible' : ''}`}
        >
          {PROFILES.map((profile, idx) => (
            <div
              key={profile.key}
              className={`flex flex-col items-center text-center ${
                idx === 1 ? 'stagger-2' : idx === 2 ? 'stagger-3' : ''
              }`}
            >
              {/* Icon circle */}
              <div className="w-16 h-16 flex items-center justify-center rounded-full border border-current mb-8 relative"
                style={{ borderColor: 'currentColor' }}>
                <i className={`${profile.icon} text-2xl ${profile.color}`}></i>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-anthracite-800 font-medium mb-5">
                {t(`perchi.${profile.key}.title`)}
              </h3>
              <p className="font-sans text-sm md:text-base text-anthracite-400 leading-relaxed max-w-xs">
                {t(`perchi.${profile.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PerChiSection;
